import PropTypes from 'prop-types'
import { useState } from 'react'

import styles from './Buscador.module.css'

const BUSCADOR_DELAY_MS = 500

export const Buscador = ({
  busqueda,
  setBusqueda,
  onChange,
  placeholder = 'Buscar...'
}) => {
  const [timeoutId, setTimeoutId] = useState(null)

  const handleInputChange = (e) => {
    const nuevoValor = e.target.value
    setBusqueda(nuevoValor)
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    const valor = nuevoValor.trim().toLowerCase()
    const id = setTimeout(() => {
      onChange(valor)
    }, BUSCADOR_DELAY_MS)
    setTimeoutId(id)
  }

  return (
    <input
      type="text"
      className={styles.buscador}
      value={busqueda}
      onChange={handleInputChange}
      placeholder={placeholder}
    />
  )
}

Buscador.propTypes = {
  busqueda: PropTypes.string.isRequired,
  setBusqueda: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}
